import $ from 'jquery'

/**
 * Activate home page collection tabs
 */
export const init = async function () {
  const tabControls = $('.js-index-tabs-control')
  const tabPanels = $('.js-index-tabs-panel')

  if (!tabPanels) {
    return
  }

  tabControls.on('click', function (evt) {
    evt.preventDefault()

    const tabControl = $(evt.delegateTarget)
    const tabFilter = [
      '[data-tab-letter="',
      tabControl.attr('data-tab-letter') || 'a',
      '"]'
    ].join('')

    tabControls.not(tabFilter).removeClass('is-active')
    tabControl.addClass('is-active')

    tabPanels.not(tabFilter).removeClass('is-active')
    tabPanels.filter(tabFilter).addClass('is-active')
  })
}
